import { Suspense } from 'react';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import ReactGA from 'react-ga';
import './App.css';
import Application from './components/Application';

posthog.init('phc_nxbrDSUpynpf2lEMbWTmNVdQDJVvERyqkgSq7wSiSLx', {
  api_host: `${window.location.origin}/ingest`,
  ui_host: 'https://app.posthog.com',
});

ReactGA.initialize('GTM-T2P4QQ3D');

if (import.meta.env.VITE_APP_ENV == 'production') {
  Sentry.init({
    dsn: 'https://7eab256554950aeb91a09ba85bc1a456@o4507051703336960.ingest.us.sentry.io/4507051750588416',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    tracePropagationTargets: ['https://app.findneedle.co'],
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

function App() {
  return (
    <Suspense fallback={<></>}>
      <Application />
    </Suspense>
  );
}

export default App;
